import * as userRequest from "@/utils/userRequest";

export default async function checkPaymentStatusService(
    code: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get(`/payment-gateway/transaction-status/${code}`);

        if (res.success) {
            onSuccess && onSuccess(res);
            return res;
        }
        throw new Error(res.message);
    } catch (err) {
        console.error("🚀 ~ checkPaymentStatusService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
